import React from "react";

class UmpireCellFormatter extends React.Component {
  render() {
    return this.props.value.name;
  }
}

export default UmpireCellFormatter;
